import React from "react";
import { location } from "../Icons/icons";
import { Marker } from "react-leaflet";

/**
 * A marker for the user's location
 */
const LocationMaker = (props) => {
  if (props.yourLocation)
    return (
      <Marker
        position={{ lat: props.yourLocation.lat, lng: props.yourLocation.lng }}
        icon={location}
        zIndexOffset={1000}
      />
    );
  else return null;
};

export default LocationMaker;
